import { FbmResource } from 'models/fbm-resource/_types';
import { User } from 'models/user/_types';
import { Visit } from 'models/visit/_types';
import { Identifier } from 'types/utilityTypes';

export enum AppointmentStatus {
  Scheduled = 'scheduled',
  Completed = 'completed',
  Canceled = 'cancelled',
  LateCanceled = 'late_cancelled',
}

export interface Appointment {
  id: Identifier;
  scheduleId: Identifier;
  scheduledAppointmentId: Identifier;
  status: AppointmentStatus;
  rescheduleDate: string;
  serviceName: string;
  cancellationFee: number;
  noshowFee: number;
  locationName: string;
  trainerIds: Identifier[];
  primaryTrainerNames: string[];
  planWorkoutIds: Identifier[];
  trainerNames: string[];
  startTime: Date;
  endTime: Date;
  expiresOn: Date | null;
  notes: string;
  description: string;
  calendarId: Identifier;
  remainingVisits: number;
  isGroupClass: boolean;
  maxVisits: number;
  zoomMeeting: ZoomMeeting;

  // associations
  visits: Visit[];
  entries: WaitListEntry[];
  service: Service;
  location: Location;
  primaryTrainers: User[];
  secondaryTrainers: User[];
  resources: FbmResource[];

  // id versions of associations
  serviceId: Identifier;
  locationId: Identifier;
  primaryTrainerIds: Identifier[];
  secondaryTrainerIds: Identifier[];
}

export interface Location {
  id: Identifier;
  name: string;
  address: string;
}

export interface WaitListEntry {
  id: Identifier;
  user?: User;
  userId: Identifier;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  status: string;
  appointmentId: Identifier;
}

export enum WaitListType {
  FirstComeFirstServe = 'first_come_first_serve',
  AutoAdd = 'auto_add',
}

export interface Service {
  id: Identifier;
  name: string;
  description: string;
  thumbnail: string;
  largeThumbnail: string;
  waitlist: boolean; // this service supports waitlisting
  defaultTime: number; // default time in minutes
  showBooked: boolean; // can i show other users to non-trainers
  disableCancellations: boolean; // can i cancel this appointment
  waitlistType: WaitListType;
  waitlistCap: number;
  cancellationPolicyHours: number;
  autoChargeCancellation: boolean;
  cancellationFee: number;
}

interface ZoomMeeting {
  id: Identifier;
  joinUrl: string;
  startUrl: string;
  password: string;
}

export interface EligibilityCheck {
  eligible: boolean;
  reason: string;
  data: any;
  count: number;
  interval: number;
  trainerReason: string;
  reasonMessage: string;
  visitsRemaining: number;
}
